module.exports = __webpack_public_path__ + "img/logo-color-120.8574f9fd.png";